import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import FeatureBadgeRow, { TFeatureBadge } from "../feature-badge-row";
import {
  FEATURE_SET_TAG_WIDTH_LARGE,
  FEATURE_SET_TAG_WIDTH_MEDIUM
} from "../feature-badge-row/feature-tag-constants";

const ActiveFeatures = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const advancedStore = getUserAdvancedStore();
  const {
    isPaidSilver,
    isPaidGold,
    isPaidBlack,
    isPaidPlatinum,
    isPaidVIP,
    isPaidPower,
    isPaidBoost,
    isPaidRewind,
    isPaidPlus,
    isSubscribedVIP,
    isSubscribedSilver,
    isSubscribedGold,
    isSubscribedBlack,
    isSubscribedPlatinum,
    isSubscribedPower,
    isSubscribedRewind,
    isSubscribedBoost,
    isSubscribedPlus,
    hasAccessToBoosts,
    hasAccessToRewinds,
    hasAccessToReadReceipts,
    hasAccessToNewConversationsDaily,
    hasAccessToNewConversationsWeekly,
    hasAccessToOpenUnlimitedConversations,
    hasAccessToLikes,
    hasAccessToLikesDaily,
    hasRemainingBoosts,
    hasRemainingRewinds,
    hasRemainingReadReceipts,
    hasRemainingNewConversationsDaily,
    hasRemainingNewConversationsWeekly,
    hasRemainingLikes,
    hasRemainingLikesDaily
  } = advancedStore.getUserSubscriptionStatus.get();

  const badges: TFeatureBadge[] = [
    {
      tag: i18n.get("BOOST"),
      tagColor:
        hasRemainingBoosts ||
        isSubscribedVIP ||
        isSubscribedGold ||
        isSubscribedBlack ||
        isSubscribedPlatinum ||
        isSubscribedPower ||
        isSubscribedBoost
          ? colors.all.vipGold
          : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_MEDIUM,
      isActive:
        hasAccessToBoosts ||
        isPaidVIP ||
        isPaidGold ||
        isPaidBlack ||
        isPaidPlatinum ||
        isPaidPower ||
        isPaidBoost
    },
    {
      tag: i18n.get("REWIND"),
      tagColor:
        hasRemainingRewinds ||
        isSubscribedSilver ||
        isSubscribedGold ||
        isSubscribedBlack ||
        isSubscribedPlatinum ||
        isSubscribedPower ||
        isSubscribedRewind
          ? colors.all.purple
          : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_MEDIUM,
      isActive:
        hasAccessToRewinds ||
        isPaidSilver ||
        isPaidGold ||
        isPaidBlack ||
        isPaidPlatinum ||
        isPaidPower ||
        isPaidRewind
    },
    {
      tag: i18n.get("READ"),
      tagColor:
        hasRemainingReadReceipts ||
        isSubscribedGold ||
        isSubscribedBlack ||
        isSubscribedPlatinum ||
        isSubscribedPower
          ? colors.all.powerPurple
          : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_MEDIUM,
      isActive:
        hasAccessToReadReceipts ||
        isPaidGold ||
        isPaidBlack ||
        isPaidPlatinum ||
        isPaidPower
    },
    {
      tag: i18n.get("CONVERSATION_BADGE"),
      tagColor:
        hasRemainingNewConversationsDaily ||
        hasRemainingNewConversationsWeekly ||
        hasAccessToOpenUnlimitedConversations ||
        isSubscribedGold ||
        isSubscribedBlack ||
        isSubscribedPlatinum
          ? colors.all.darkOrange
          : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_LARGE,
      isActive:
        hasAccessToNewConversationsDaily ||
        hasAccessToNewConversationsWeekly ||
        hasAccessToOpenUnlimitedConversations ||
        isPaidGold ||
        isPaidBlack ||
        isPaidPlatinum
    },
    {
      tag: i18n.get("LIKES"),
      tagColor:
        hasRemainingLikes ||
        hasRemainingLikesDaily ||
        isSubscribedSilver ||
        isSubscribedGold ||
        isSubscribedBlack ||
        isSubscribedPlatinum ||
        isSubscribedPlus
          ? colors.all.green
          : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_LARGE,
      isActive:
        hasAccessToLikes ||
        hasAccessToLikesDaily ||
        isPaidSilver ||
        isPaidGold ||
        isPaidBlack ||
        isPaidPlatinum ||
        isPaidPlus
    }
  ];

  return <FeatureBadgeRow labelKey={"CONSUMABLES_LANE"} badges={badges} />;
});

export default ActiveFeatures;
